/* ChasingCards — Merkliste (localStorage-basiert, bewusste Nutzer-Entscheidung:
   keine App, kein Account, kein Drittanbieter; gerätegebunden akzeptiert).

   ARCHITEKTUR: window.CCWishlist ist der EINZIGE Speicher-Layer. Alle Aufrufer
   (Herz-Buttons, Header-Zähler, Merkliste-Seite) nutzen NUR diese API und
   greifen NIE direkt auf localStorage zu. Späterer App-Umstieg = nur die
   Implementierung dieses Objekts austauschen, kein Aufrufpunkt ändert sich.

   Gespeichert werden nur Produkt-Handles (Preise/Verfügbarkeit ändern sich).
   Key ist versioniert (v1) für spätere Schema-Migration. Defensiv gegen
   kaputtes JSON und blockierten Storage (privates Fenster) — degradiert still
   auf einen Sitzungs-Speicher, crasht nie. */
(function () {
  'use strict';

  /* ============================================================
     SPEICHER-LAYER
     ============================================================ */
  var KEY = 'cc:wishlist:v1';
  var EVT = 'cc:wishlist:change';
  var memoryList = []; // Fallback, wenn localStorage blockiert ist

  var canStore = (function () {
    try {
      var t = 'cc:wishlist:probe';
      window.localStorage.setItem(t, '1');
      window.localStorage.removeItem(t);
      return true;
    } catch (e) {
      return false;
    }
  })();

  function read() {
    if (!canStore) return memoryList.slice();
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var data = JSON.parse(raw);
      if (!Array.isArray(data)) return [];
      return data.filter(function (h) { return typeof h === 'string' && h !== ''; });
    } catch (e) {
      return []; // kaputtes JSON -> leere Liste, kein Crash
    }
  }

  function write(list) {
    if (canStore) {
      try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* still degradieren */ }
    } else {
      memoryList = list.slice();
    }
    broadcast(list);
  }

  function broadcast(list) {
    document.dispatchEvent(new CustomEvent(EVT, {
      detail: { handles: list.slice(), count: list.length }
    }));
  }

  window.CCWishlist = {
    EVENT: EVT,
    persistent: canStore, // false = privates Fenster o.ä. (nur Sitzung)
    list: function () { return read(); },
    count: function () { return read().length; },
    has: function (handle) { return read().indexOf(handle) !== -1; },
    add: function (handle) {
      if (!handle) return;
      var l = read();
      if (l.indexOf(handle) === -1) { l.push(handle); write(l); }
    },
    remove: function (handle) {
      var l = read();
      var i = l.indexOf(handle);
      if (i !== -1) { l.splice(i, 1); write(l); }
    },
    toggle: function (handle) {
      if (this.has(handle)) { this.remove(handle); return false; }
      this.add(handle);
      return true;
    },
    clear: function () { write([]); }
  };

  // Mehrere offene Tabs konsistent halten
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) broadcast(read());
  });

  /* ============================================================
     UI: HERZ-BUTTONS + HEADER-ZÄHLER
     Zustand IMMER clientseitig (Section-Caching-sicher) — der Server
     rendert neutral (leer, aria-pressed=false), hier wird nachgezogen.
     ============================================================ */
  function syncButton(btn, list) {
    var active = list.indexOf(btn.getAttribute('data-cc-wl-toggle')) !== -1;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Von der Merkliste entfernen' : 'Zur Merkliste hinzufügen');
    var txt = btn.querySelector('[data-cc-wl-text]');
    if (txt) {
      var t = active ? btn.getAttribute('data-text-active') : btn.getAttribute('data-text-idle');
      if (t) txt.textContent = t;
    }
  }

  function syncAll() {
    var list = read();
    document.querySelectorAll('[data-cc-wl-toggle]').forEach(function (btn) { syncButton(btn, list); });
    document.querySelectorAll('[data-cc-wl-count]').forEach(function (el) {
      var n = list.length;
      el.hidden = n === 0;
      var num = el.querySelector('[data-cc-wl-num]');
      if (num) num.textContent = n < 100 ? String(n) : '99+';
      var sr = el.querySelector('[data-cc-wl-sr]');
      if (sr) sr.textContent = n === 1 ? '1 Produkt auf der Merkliste' : n + ' Produkte auf der Merkliste';
    });
  }

  // Delegation: funktioniert auch für nachgeladene Karten (Facets-AJAX etc.)
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cc-wl-toggle]') : null;
    if (!btn) return;
    // Karten sind ganzflächige Links — Klick darf NICHT die Karte auslösen
    e.preventDefault();
    e.stopPropagation();
    window.CCWishlist.toggle(btn.getAttribute('data-cc-wl-toggle'));
  });

  document.addEventListener(EVT, syncAll);

  // Nachgeladene Inhalte (Facets, „Mehr laden") bekommen ihren Zustand nachgezogen
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && ((n.matches && n.matches('[data-cc-wl-toggle]')) || (n.querySelector && n.querySelector('[data-cc-wl-toggle]')))) {
          syncAll();
          return;
        }
      }
    }
  });

  /* ============================================================
     MERKLISTE-SEITE (nur aktiv, wenn [data-cc-wl-page] existiert)
     Nachladen pro Handle über die Section Rendering API
     (/products/<handle>?section_id=cc-wishlist-item) — rendert die
     ECHTE cc-product-card serverseitig (Regel 7: Karte nicht in JS
     nachbauen). 404 = Produkt weg -> sauber aus der Liste entfernen.
     ============================================================ */
  function initPage() {
    var page = document.querySelector('[data-cc-wl-page]');
    if (!page) return;

    var sectionId = page.getAttribute('data-cc-wl-section');
    var grid = page.querySelector('[data-cc-wl-grid]');
    var body = page.querySelector('[data-cc-wl-body]');
    var loading = page.querySelector('[data-cc-wl-loading]');
    var empty = page.querySelector('[data-cc-wl-empty]');
    var countEl = page.querySelector('[data-cc-wl-page-count]');
    var notice = page.querySelector('[data-cc-wl-notice]');
    var persistHint = page.querySelector('[data-cc-wl-persist]');
    var clearBtn = page.querySelector('[data-cc-wl-clear]');
    var busy = false;

    if (persistHint && !window.CCWishlist.persistent) persistHint.hidden = false;

    function show(state) {
      if (loading) loading.hidden = state !== 'loading';
      if (body) body.hidden = state !== 'list';
      if (empty) empty.hidden = state !== 'empty';
    }

    function renderedHandles() {
      return Array.prototype.map.call(grid.querySelectorAll('[data-cc-wl-item]'), function (li) {
        return li.getAttribute('data-cc-wl-item');
      });
    }

    function updateCount() {
      if (!countEl) return;
      var n = grid.querySelectorAll('[data-cc-wl-item]').length;
      countEl.hidden = n === 0;
      countEl.textContent = n === 1 ? '1 Produkt' : n + ' Produkte';
    }

    function showNotice(text) {
      if (!notice) return;
      notice.textContent = text;
      notice.hidden = !text;
    }

    function fetchCard(handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sectionId))
        .then(function (r) {
          // Produkt weg (gelöscht/archiviert): 404 ODER 200 mit leer gerenderter
          // Section (product = nil -> kein data-cc-wl-card im HTML)
          if (r.status === 404) return { handle: handle, gone: true };
          if (!r.ok) return { handle: handle, failed: true }; // 5xx etc.: behalten
          return r.text().then(function (html) {
            if (html.indexOf('data-cc-wl-card') === -1) return { handle: handle, gone: true };
            return { handle: handle, html: html };
          });
        })
        .catch(function () { return { handle: handle, failed: true }; }); // Netzfehler: behalten
    }

    function load() {
      var handles = window.CCWishlist.list();
      if (!handles.length) { show('empty'); updateCount(); return; }
      busy = true;
      show('loading');
      Promise.all(handles.map(fetchCard)).then(function (results) {
        var goneCount = 0;
        var failedCount = 0;
        grid.innerHTML = '';
        var parser = new DOMParser();
        results.forEach(function (res) {
          if (res.gone) { window.CCWishlist.remove(res.handle); goneCount++; return; }
          if (res.failed) { failedCount++; return; }
          var doc = parser.parseFromString(res.html, 'text/html');
          var card = doc.querySelector('[data-cc-wl-card]');
          if (!card) { failedCount++; return; }
          var li = document.createElement('li');
          li.className = 'grid__item';
          li.setAttribute('data-cc-wl-item', res.handle);
          while (card.firstChild) li.appendChild(card.firstChild);
          grid.appendChild(li);
        });
        busy = false;
        var msgs = [];
        if (goneCount) msgs.push(goneCount === 1 ? '1 Produkt ist nicht mehr verfügbar und wurde entfernt.' : goneCount + ' Produkte sind nicht mehr verfügbar und wurden entfernt.');
        if (failedCount) msgs.push('Einige Produkte konnten gerade nicht geladen werden.');
        showNotice(msgs.join(' '));
        if (grid.children.length) { show('list'); } else { show('empty'); }
        updateCount();
        syncAll(); // Herzen der frisch gerenderten Karten auf „aktiv" setzen
      });
    }

    // Änderungen (eigener Klick, anderer Tab): Entfernungen ohne Refetch,
    // Neuzugänge per Nachladen
    document.addEventListener(EVT, function () {
      if (busy) return;
      var list = window.CCWishlist.list();
      var shown = renderedHandles();
      var needsFetch = list.some(function (h) { return shown.indexOf(h) === -1; });
      if (needsFetch) { load(); return; }
      shown.forEach(function (h) {
        if (list.indexOf(h) === -1) {
          var li = grid.querySelector('[data-cc-wl-item="' + h + '"]');
          if (li) li.remove();
        }
      });
      if (!grid.children.length) show('empty');
      updateCount();
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        var q = clearBtn.getAttribute('data-confirm') || 'Wirklich alle Produkte von der Merkliste entfernen?';
        if (window.confirm(q)) window.CCWishlist.clear();
      });
    }

    load();
  }

  function init() {
    syncAll();
    mo.observe(document.body, { childList: true, subtree: true });
    initPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
